__turbopack_context__.v({
  "container": "_9xMYgW_container",
  "eachLogoStyles": "_9xMYgW_eachLogoStyles",
  "eachLogoStylesNoBorderBottom": "_9xMYgW_eachLogoStylesNoBorderBottom",
  "headerMenuButton": "_9xMYgW_headerMenuButton",
  "headerMenuButtonActive": "_9xMYgW_headerMenuButtonActive",
  "headerTabMenuWrapper": "_9xMYgW_headerTabMenuWrapper",
  "nextBtn": "_9xMYgW_nextBtn",
  "prevBtn": "_9xMYgW_prevBtn",
  "span2Cell": "_9xMYgW_span2Cell",
  "statisticContainer": "_9xMYgW_statisticContainer",
  "statisticDescribe": "_9xMYgW_statisticDescribe",
  "statisticHeaderMenu": "_9xMYgW_statisticHeaderMenu",
  "statisticHeaderMenuSrollControl": "_9xMYgW_statisticHeaderMenuSrollControl",
  "statisticHeaderMenuSrollControlDiactive": "_9xMYgW_statisticHeaderMenuSrollControlDiactive",
  "statisticItemWrapper": "_9xMYgW_statisticItemWrapper",
  "statisticLogoContainer": "_9xMYgW_statisticLogoContainer",
  "statisticLogoWrapper": "_9xMYgW_statisticLogoWrapper",
  "statisticNumber": "_9xMYgW_statisticNumber",
  "statisticNumberContainer": "_9xMYgW_statisticNumberContainer",
  "tabTitle": "_9xMYgW_tabTitle",
  "topContent": "_9xMYgW_topContent",
  "topContentP": "_9xMYgW_topContentP",
  "unitStatistic": "_9xMYgW_unitStatistic",
});
